import React from "react";
import Table from "../../../components/Table/Table";

const ImportSurveyAudienceTable = ({
  classes,
  classIds,
  studentsByClass,
  selectedStudentIds,
  onToggleStudent,
  onToggleAll,
}) => {
  return (
    <>
      {classIds.map((classId) => {
        const cls = classes.find((c) => Number(c.id) === classId);
        const students = studentsByClass[classId] || [];
        const allSelected =
          students.length > 0 &&
          students.every((s) => selectedStudentIds.includes(s.id));

        const cols = [
          {
            title: () => (
              <input
                type="checkbox"
                checked={allSelected}
                onChange={() => onToggleAll(students, !allSelected)}
              />
            ),
            render: (row) => (
              <input
                type="checkbox"
                checked={selectedStudentIds.includes(row.id)}
                onChange={() => onToggleStudent(row.id)}
              />
            ),
          },
          {
            title: "Roll No.",
            key: "rollNo",
            render: (row) => row.rollNo,
            sortValue: (row) => row.rollNo,
          },
          {
            title: "Name",
            key: "name",
            render: (row) => row.name,
            sortValue: (row) => row.name,
          },
          {
            title: "Admission No.",
            key: "uuid",
            render: (row) => row.admissionNo || row.admissionNo,
            sortValue: (row) => row.admissionNo || row.admissionNo,
          },
        ];

        return (
          <div className="import-audience-class-block" key={classId}>
            <div className="import-audience-class-title">{cls?.name}</div>
            <Table cols={cols} data={students} />
          </div>
        );
      })}
    </>
  );
};

export default ImportSurveyAudienceTable;
